import type { CapabilityMap } from "@/utils/accessControl";

export interface GuestExperienceServicesVisibility {
  /** Show the Services row: any services category is available for the subscription. */
  showServices: boolean;
  /** Internal hotel services are available, so their active count can be requested. */
  hasInternalServices: boolean;
}

export function resolveGuestExperienceServicesVisibility(
  capabilities: Pick<
    CapabilityMap,
    "canUseInternalServices" | "canUseGuesteriaPartners"
  >,
): GuestExperienceServicesVisibility {
  const hasInternalServices = capabilities.canUseInternalServices;
  return {
    showServices: hasInternalServices || capabilities.canUseGuesteriaPartners,
    hasInternalServices,
  };
}
